import { render } from "./EducationDetail.vue?vue&type=template&id=4296d425&scoped=true"
import script from "./EducationDetail.vue?vue&type=script&lang=js"
export * from "./EducationDetail.vue?vue&type=script&lang=js"

import "./EducationDetail.vue?vue&type=style&index=0&id=4296d425&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4296d425"]])

export default __exports__